import script from "./Menus.vue?vue&type=script&setup=true&lang=js"
export * from "./Menus.vue?vue&type=script&setup=true&lang=js"

import "./Menus.vue?vue&type=style&index=0&id=18511a76&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18511a76"]])

export default __exports__